import React from 'react';
import './Home.css';

import Alert from '../../components/Alert/Alert.js';
import Clock from '../../components/Clock/Clock.js';
import WeatherQuick from '../../components/WeatherQuick/WeatherQuick.js';

import {
  inject,
  observer
} from 'mobx-react';

import {
  formatTemperature,
  get3HourIntervalWeather,
  getWeatherBackgroundImage,
  getSuggestedClothingForDay,
} from '../../utils/weather';

import {
  setBackground,
  setBackgroundImage
} from '../../utils/style.js';
import {
  addMinutesChangeEvent,
  get12HourTimeHour,
  get12HourPeriod,
  getDateFromSeconds,
  removeMinutesChangeEvent,
} from '../../utils/datetime';

class Home extends React.Component {

  constructor(props) {
    super(props);

    this.setHomeBackground = this.setHomeBackground.bind(this);

    this.state = {
      nextAlarm: undefined,
      date: new Date()
    }
  }

  componentWillMount() {
    setBackground('gray');

    this.props.alarmStore.onLoad(alarmStore => {
      this.setState({
        nextAlarm: alarmStore.next
      });
    });

    this.props.weatherStore.onLoad(this.setHomeBackground);

    addMinutesChangeEvent('home_clock', date => {
      this.setState({
        date: date
      })
    });
  }

  componentDidUpdate() {
    this.setHomeBackground();
  }

  componentWillUnmount() {
    removeMinutesChangeEvent('home_clock');
  }

  render() {
    return (
      <div className='home'>
        <div className='home__next-alarm'>
          {this.state.nextAlarm ?
            <Alert corner='tr'>
              Next Alarm: {this.state.nextAlarm.timeUntil}
            </Alert>
          : null}
        </div>
        <div className='home__clock'>
          <Clock date={this.state.date} />
        </div>
        {this.props.settingsStore.sleepMode ? null :
          <div className='home__note'>
            <Alert>
              Everything is ok and everything will be ok. Wear a sweater :)
            </Alert>
          </div>
        }
        {this.props.weatherStore.isLoading || this.props.settingsStore.sleepMode ? null :
          <div className='home__weather'>
            <WeatherQuick
              currentTemperature={formatTemperature(this.props.weatherStore.currentTemp)}
              hourlyData={get3HourIntervalWeather(this.props.weatherStore.upcomingHours, 5, 0).map(hourObj => {
                const date = getDateFromSeconds(hourObj.time);

                return {
                  icon: hourObj.icon,
                  temperature: formatTemperature(hourObj.temperature),
                  time: `${get12HourTimeHour(date)}${get12HourPeriod(date)}`
                }
              })}
              suggestedClothing={getSuggestedClothingForDay(this.props.weatherStore.weather.daily.data[0])}
            />
        </div>}
      </div>
    );
  }

  setHomeBackground() {
    if (this.props.settingsStore.sleepMode) {
      setBackground('black');
    }
    else if (this.props.weatherStore.currently) {
      setBackgroundImage(
        getWeatherBackgroundImage(this.props.weatherStore.currently.icon)
      );
    }
  }
}

export default inject('alarmStore', 'settingsStore', 'weatherStore')(observer(Home));



// WEBPACK FOOTER //
// ./src/views/Home/index.js